import { useRouter } from '@application/utils';
import beFlag from '@assets/be.svg';
import frFlag from '@assets/fr.svg';
import nlFlag from '@assets/nl.svg';
import deFlag from '@assets/de.svg';
import chFlag from '@assets/ch.svg';
import euFlag from '@assets/eu.svg';
import {
  Button,
  Card,
  InputRadioField,
  Modal,
  ModalTitle,
  Section,
} from '@presentation/components';
import { Form, useFormikContext } from 'formik';
import type { FC } from 'react';
import { Label } from './components/Label';
import type {
  SelectPreferredCountryLanguageFormValues,
  SelectPreferredCountryLanguageModalProps,
} from './types';

export * from './types';

export const SelectPreferredCountryLanguageModal: FC<SelectPreferredCountryLanguageModalProps> = (
  props,
) => {
  const { modal, language } = props;
  const { translate } = useRouter();
  const { isSubmitting } = useFormikContext<SelectPreferredCountryLanguageFormValues>();
  return (
    <Modal {...modal} onCloseClick={undefined}>
      <Card size="large" isModal>
        <ModalTitle>
          {translate('common.modals.languageSelector.title', { lng: language })}
        </ModalTitle>

        <Section>
          <Form>
            <InputRadioField<string>
              name="country"
              separated
              langSelector
              options={[
                {
                  value: 'be/nl',
                  label: <Label flag={beFlag} country="België" language="Nederlands" />,
                },
                {
                  value: 'be/fr',
                  label: <Label flag={beFlag} country="Belgique" language="Français" />,
                },
                {
                  value: 'fr/fr',
                  label: <Label flag={frFlag} country="France" language="Français" />,
                },
                {
                  value: 'nl/nl',
                  label: <Label flag={nlFlag} country="Nederland" language="Nederlands" />,
                },
                {
                  value: 'de/de',
                  label: <Label flag={deFlag} country="Deutschland" language="Deutsch" />,
                },
                {
                  value: 'ch/fr',
                  label: <Label flag={chFlag} country="Suisse" language="Français" />,
                },
                {
                  value: 'ch/de',
                  label: <Label flag={chFlag} country="Schweiz" language="Deutsch" />,
                },
                {
                  value: 'eu/en',
                  label: <Label flag={euFlag} country="Europe" language="English" />,
                },
                // {
                //   value: 'de/en',
                //   label: <Label flag={deFlag} country="Germany" language="English" />,
                // },
              ]}
            />
            <Section centerChildren>
              <Button color="blue" size="large" shrink type="submit" loading={isSubmitting}>
                {translate('common.buttons.confirm', { lng: language })}
              </Button>
            </Section>
          </Form>
        </Section>
      </Card>
    </Modal>
  );
};
